'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Club = void 0;
var $ = require("jquery");
var Club = /** @class */ (function () {
    function Club() {
        this.naviNumber = 1;
        this.naviBoxKey = '.trigClubNavi';
        this.specialBoxKey = '.bulletClubSpecialBox';
        this.specialBoxesKey = '.bulletClubSpecialBoxes';
        this.specialBoxWidth = 0;
        var self = this;
        if ($(this.specialBoxesKey).length > 0) {
            this.naviNumber = 1;
            this.specialBoxWidth = $(this.specialBoxKey).eq(0).width();
            // console.log(this.specialBoxWidth);
        }
        // navi 移動
        $(this.naviBoxKey).click(function () {
            var number = $(this).data('number');
            self.slide(number);
        });
        // prev, next
        $('.trigClubPrevNext').click(function (e) {
            e.preventDefault();
            var type = $(this).data('type');
            var number = self.naviNumber;
            if (type == 'prev') {
                number--;
                if (number < 1) {
                    number = 1;
                }
            }
            else if (type == 'next') {
                number++;
                if (number > $(self.specialBoxKey).length) {
                    number = $(self.specialBoxKey).length;
                }
            }
            self.slide(number);
        });
    }
    Club.prototype.slide = function (number) {
        $(this.naviBoxKey).removeClass('current');
        $(this.naviBoxKey + '[data-number="' + number + '"]').addClass('current');
        var specialSlide = (this.specialBoxWidth) * (number - 1) * -1;
        // console.log(specialSlide);
        $(this.specialBoxesKey).css({ marginLeft: specialSlide });
        this.naviNumber = number;
    };
    return Club;
}());
exports.Club = Club;
exports.default = Club;
